/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Dialog_ConfirmInputs */



/**
* | output |
* | --- |
* | "Set Position" |
*
* @param {Input_Position_Dialog_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_dialog_confirm = /** @type {((inputs?: Input_Position_Dialog_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Dialog_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Définir la Position")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position einstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imposta posizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Установить позицию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Establecer posición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置を設定する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति निर्धारित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição definida")
	return /** @type {LocalizedString} */ ("Set Position")
});